import { createContext } from 'react';

export const PortalContext = createContext(null);
